import API from '../../utils/api';
import * as types from './types';
import { AGENT_SERVICE_ENDPOINT_URL } from '../../constants/defaultValues';
import { formatMarkets } from '../../utils/render';
import {
    CLEAR_EVENT_DETAILS,
    SET_ALL_MARKETS_EVENT_REMOVED,
    SET_EVENT_SEARCH_PROPS,
    SET_SHORTCODE_SEARCH_PROPS,
} from './types';
import BaseModel from '../../models/BaseModel';
import ExtendedEventDetailsModel from '../../models/agent/extended-event-details/extended-event-details-model';

export const getEventDetails = id => async (dispatch, getStore) => {
    dispatch({
        type: types.GET_EVENT_DETAILS_REQUEST,
    });
    await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/events/details?eventId=${id}`)
        .then(response => {
            const { info, item } = response.data;

            if (info.success) {
                dispatch(setEventDetails(BaseModel.construct(ExtendedEventDetailsModel, item)));
            }
        })
        .catch(err => {
            console.log({ err });
            if (err.response?.status === 404) {
                window.location.replace('/');
            }
            dispatch({
                type: types.GET_EVENT_DETAILS_FAILED,
            });
        });
};

export const setEventDetails = event => (dispatch, getStore) => {
    const store = getStore();
    const { markets: marketDescriptions, outcomes: outcomeDescriptions } = store.descriptions.data;

    const formattedItem = {
        ...event,
        markets: formatMarkets({
            markets: event.markets,
            marketDescriptions,
            outcomeDescriptions,
        }),
    };

    dispatch({
        type: types.GET_EVENT_DETAILS_SUCCESS,
        payload: formattedItem,
    });
};

export const setEventSearchProps = props => ({
    type: SET_EVENT_SEARCH_PROPS,
    payload: props,
});

export const setShortcodeSearchProps = props => ({
    type: SET_SHORTCODE_SEARCH_PROPS,
    payload: props,
});

export const clearEventDetails = () => ({
    type: CLEAR_EVENT_DETAILS,
});

export const setAllMarketsEventRemoved = payload => ({
    type: SET_ALL_MARKETS_EVENT_REMOVED,
    payload,
});
